module.exports = __webpack_public_path__ + "img/sac-es-ES.0d58d3d7.png";